import React from "react";
import { FaStar } from "react-icons/fa";

import styles from "../../styles/pages/product/ProductDetailsPage.module.css";

const ProductReviewsSummaryHeader = ({
  averageRating,
  reviewCount,
  isAuthenticated,
  isReviewFormOpen,
  hasExistingReview = false,
  onToggleReviewForm,
  onLoginToReview,
}) => {
  return (
    <div className={styles.reviewsHeader}>
      <div>
        <h3 className={styles.reviewsTitle}>Reviews</h3>
        <div className={styles.ratingSummary}>
          <div className={styles.averageRating}>
            <span className={styles.ratingValue}>{averageRating.toFixed(1)}</span>
            <div className={styles.stars}>
              {[1, 2, 3, 4, 5].map((star) => (
                <FaStar
                  key={star}
                  className={
                    star <= Math.round(averageRating)
                      ? styles.starFilled
                      : styles.starEmpty
                  }
                  size={20}
                />
              ))}
            </div>
            <span className={styles.reviewCount}>
              ({reviewCount} {reviewCount === 1 ? "review" : "reviews"})
            </span>
          </div>
        </div>
      </div>
      {isAuthenticated ? (
        <button className={styles.writeReviewBtn} onClick={onToggleReviewForm} type="button">
          {isReviewFormOpen ? "Cancel" : hasExistingReview ? "Edit your review" : "Write a Review"}
        </button>
      ) : (
        <button className={styles.writeReviewBtn} onClick={onLoginToReview} type="button">
          Log in to Review
        </button>
      )}
    </div>
  );
};

export default ProductReviewsSummaryHeader;
